import { IconButton } from '@humanforce/mango-ui-react';

/**
 * The single way PRR-402 marks something the approved design shows but the API cannot do yet.
 *
 * Use this one component everywhere rather than re-stating the limitation in prose: a long callout
 * next to every gap drowns the screen, and three different phrasings of "not available" is three
 * things to keep in step. The icon carries the whole message in its tooltip.
 *
 * `IconButton`'s `label` serves as both the `aria-label` and the hover/focus tooltip, so this stays
 * reachable by keyboard and screen reader without a wrapper element.
 */

/** Tooltip text for controls that already expose a `tooltip` prop of their own (Button, IconButton). */
export const NOT_IMPLEMENTED_HINT = 'Not available yet';

interface NotImplementedHintProps {
  /** What is unavailable, e.g. "Deductions". Becomes "<what> is not available yet". */
  what: string;
  /** Optional sentence appended to the tooltip explaining why. */
  because?: string;
  testId?: string;
}

export const NotImplementedHint = ({ what, because, testId }: NotImplementedHintProps) => (
  <IconButton
    icon="info"
    label={because ? `${what} is not available yet. ${because}` : `${what} is not available yet`}
    variant="tertiary"
    size="small"
    testId={testId ?? 'pay-run-not-implemented'}
  />
);
